import React from 'react';
import './style.scss';
const CustomLoader = () => {
  return (
    <div className='custom-loader'>
      <div className='loader-txt'>Loading</div>
    </div>
  );
};

export default CustomLoader;
